// smoke-alumno (S11, 20-oct-2026): la huella del aparato sin dejar un contexto de audio vivo.
//
// FingerprintJS 5.2.0 lee la latencia de audio en WebKit (Safari del iPhone y el WebView de la app) con
// `new AudioContext().baseLatency` y nunca cierra ese contexto. Un contexto de audio vivo puede tomar la
// sesion de audio del telefono y pausar la musica del usuario (Spotify, Apple Music). Aqui, mientras corre
// `fp.get()`, todo contexto que se cree se cierra en cuanto se leyo: la huella lee el mismo numero (lo lee
// en la misma expresion en que lo crea), asi que el `visitorId` no cambia.
export async function obtenerHuella(fp) {
  const ventana = typeof window !== 'undefined' ? window : null;
  const Original = ventana ? ventana.AudioContext : undefined;
  if (typeof Original !== 'function') return fp.get();
  function ContextoQueSeCierra(...args) {
    const ctx = new Original(...args);
    Promise.resolve().then(() => {
      try {
        const r = ctx.close();
        if (r && typeof r.catch === 'function') r.catch(() => {});
      } catch (e) { /* nada */ }
    });
    return ctx;
  }
  ContextoQueSeCierra.prototype = Original.prototype;
  ventana.AudioContext = ContextoQueSeCierra;
  try {
    return await fp.get();
  } finally {
    if (ventana.AudioContext === ContextoQueSeCierra) ventana.AudioContext = Original;
  }
}
